import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "name",
      label: "Device Name",
      value: submittedData.name,
    },
    {
      type: "standard",
      id: "imei",
      label: "Device ID",
      value: submittedData.imei,
    },
    // {
    //   type: "standard",
    //   id: "type",
    //   label: "Type",
    //   value: submittedData.type,
    // },
    {
      type: "standard",
      id: "active",
      label: "Activation",
      value: submittedData.active,
    },
    {
      type: "standard",
      id: "employeeName",
      label: "Assigned User",
      value: submittedData.employeeName,
    },
  ];

  return (
    <Grid item xs={12}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
